/* The power script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO web: the live packages page script, 2026-09-17 capture. Two edits only: short ids, and figures of 1,000 and over carry a separator. */

(function () {
  var root = document.documentElement;
  if (!root || root.dataset.xgoPower) return;
  root.dataset.xgoPower = '1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO  = 'IntersectionObserver' in window;
  var SENS   = { yes: 'Yes', opt: 'Optional', na: 'Not fitted' };
  /* ---------- power system: swap a detail into the lead shot ----------
     A swap, not a replace - the lead image moves into the frame you
     clicked, so nothing is lost and clicking again puts it back.
     Delegated, so it survives any future re-render of the strip. */
  var pwrMain = root.querySelector('[data-pwr-main]');
  var pwrRail = root.querySelector('[data-pwr-rail]');
  if (pwrMain && pwrRail) {
    var mainImg = pwrMain.querySelector('img');
    pwrRail.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-pwr-t]') : null;
      if (!t) return;
      var thumb = t.querySelector('img');
      if (!thumb || !mainImg) return;
      var big = { src: mainImg.getAttribute('src'), srcset: mainImg.getAttribute('srcset'), alt: mainImg.alt };
      var sml = { src: thumb.getAttribute('src'), srcset: thumb.getAttribute('srcset'), alt: thumb.alt };
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        pwrMain.classList.add('is-swap');
        window.setTimeout(function () {
          mainImg.setAttribute('src', sml.src);
          if (sml.srcset) mainImg.setAttribute('srcset', sml.srcset); else mainImg.removeAttribute('srcset');
          mainImg.alt = sml.alt;
          thumb.setAttribute('src', big.src);
          if (big.srcset) thumb.setAttribute('srcset', big.srcset); else thumb.removeAttribute('srcset');
          thumb.alt = big.alt;
          pwrMain.classList.remove('is-swap');
        }, reduce ? 0 : 150);
      };
      pre.src = sml.src;
    });
  }
})();
